import { Observable } from 'rxjs/Rx';
import {AgentService} from '../shared/service/agent.service';
import {SessionService} from '../shared/service/session.service';
import {ErrorhandleService} from './service/errorhandle.service';
import {Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, AfterViewInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import * as $ from 'jquery';
import { AlertComponent } from './alert/alert.component';
import { Alert, AlertType } from 'app/model/shared/alert';


@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AgentComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(AlertComponent)
  alertComponent: AlertComponent;

  _isLogin: Boolean = this.agentService._isLogin;
  _loginSubscription: Subject<boolean>;

  constructor(private _router: Router,
    private errorHandle: ErrorhandleService,
    private sessionService: SessionService,
    private agentService: AgentService) {
    this._loginSubscription = this.agentService._loginSubscription;
    this._loginSubscription.subscribe((value) => {
      this._isLogin = value;
    });

    $(window).resize(function() {
      const bodyHeight = $('body').prop('scrollHeight');
      const containerHeight = $('.agent-content-wrap').prop('scrollHeight');
      const topMenuHeight = $('.agent-menu-top-wrap').prop('scrollHeight');
      const applyHeight = containerHeight;
      $('.agent-menu-left-container').height(applyHeight);
      $('.popup-wrap').height(applyHeight + topMenuHeight);
    });

    $(document).ready(
      function() {
        const target = $('app-agent')[0];
        // create an observer instance
        const observer = new MutationObserver(function(mutations) {
          const bodyHeight = $('body').prop('scrollHeight');
          const containerHeight = $('.agent-content-wrap').prop('scrollHeight');
          const topMenuHeight = $('.agent-menu-top-wrap').prop('scrollHeight');
          const applyHeight = containerHeight;
          $('.agent-menu-left-container').height(applyHeight);
          $('.popup-wrap').height(applyHeight + topMenuHeight);

        });

        // configuration of the observer:
        const config = {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        };

        // pass in the target node, as well as the observer options
        observer.observe(target, config);
      }
    );

    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(function() {
          const bodyHeight = $('body').prop('scrollHeight');
          const containerHeight = $('.agent-content-wrap').prop('scrollHeight');
          const topMenuHeight = $('.agent-menu-top-wrap').prop('scrollHeight');
          const applyHeight = containerHeight;
          $('.agent-menu-left-container').height(applyHeight);
          $('.popup-wrap').height(applyHeight + topMenuHeight);
        }, 100);
      }
    });
  }

  ngOnInit() {
    if (this._isLogin) {
      this._router.navigate(['/agent/home'], {replaceUrl: true});
    } else {
      this._router.navigate(['/agent/login'], {replaceUrl: true});
    }
  }
  ngOnDestroy(): void {
    this._loginSubscription.unsubscribe();
    return;
  }

  ngAfterViewInit(): void {
    const target = $('#tab-holder')[0];
    const separatorHeight = 2;
    // create an observer instance
    const observer = new MutationObserver(function(mutations) {

      const tabs = $(target).children();
      const separators = tabs.toArray().filter(val => $(val).height() === separatorHeight);
      let skip = 0 || separators.length;
      tabs.each((idx, val) => {
        if ($(val).height() === separatorHeight) {
          skip--;
          return;
        }
        const holderHeight = $(target).height();
        const prev = tabs[idx - 1];
        const isSeparator = ($(val).height() === separatorHeight);

        if (separators.length > 0) {
          separators.forEach((_val, _idx, _arr) => {
            if (!$(_val).next().length) {
              $(_val).remove();
            }
          });
        }

        if (prev && skip <= 0) {
          if (Math.abs(val.offsetTop - prev.offsetTop) > 10) {
            $('<div style="height : ' + separatorHeight + 'px; background : #d8dbe0;"></div>').insertBefore(val);
          }
        }
      });
    });

    // configuration of the observer:
    const config = {
      childList: true,
      subtree: true,
    };

    // passing the target node and the observer options
    observer.observe(target, config);
  }

  alert (message: string) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.message = message;
    this.alertResponse(alert);
  }

  alertDetail (message: string, emphasis: boolean) {
    const alert: Alert = new Alert(AlertType.Alert, emphasis);
    alert.message = message;
    this.alertResponse(alert);
  }

  alertResponse (data) {
    const alert: Alert = data;
    alert.type = AlertType.Alert;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
  }

  alertCallback (message: string, callback: () => void) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setSubject(this, message, callback);
  }

  private subject = new Subject<any>();
  confirm(message: string, callback: (result: boolean) => void) {
    const alert: Alert = new Alert(AlertType.Confirm, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setSubject(this, message, callback);
  }

  confirmDetail(message: string, emphasis: boolean, callback: (result: boolean) => void) {
    const alert: Alert = new Alert(AlertType.Confirm, emphasis);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setSubject(this, message, callback);
  }

  showinputform(message: string, callback: (result: boolean, inputdata: string) => void) {
    const alert: Alert = new Alert(AlertType.InputConfirmForm, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setSubject(this, message, callback);
  }

  private setSubject(subContainer: any, message: string, callback: any) {
    this.subject.next({
      type: "confirm",
      text: message,
      yesFn:
        function () {
          subContainer.subject.next(); //this will close the modal
          return callback(true, this.outdata);
        },
      noFn: 
        function () {
          subContainer.subject.next();
          return callback(false, this.outdata);
        },
      setData:
        function (data) {
          this.outdata = data;
        }
    });
  }

  getContainer(): Observable<any> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/agent/agent.component.ts